module.exports = __webpack_public_path__ + "static/img/home_carousel_4new.1021fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/home_carousel_4new.jpg
// module id = Xvjd
// module chunks = 15